export var CompanyDomainCheckResult;
(function (CompanyDomainCheckResult) {
    CompanyDomainCheckResult[CompanyDomainCheckResult["VALID"] = 0] = "VALID";
    CompanyDomainCheckResult[CompanyDomainCheckResult["DUPLICATE_DOMAIN_NAME"] = 10] = "DUPLICATE_DOMAIN_NAME";
    CompanyDomainCheckResult[CompanyDomainCheckResult["INVALID_DOMAIN_NAME"] = 20] = "INVALID_DOMAIN_NAME";
})(CompanyDomainCheckResult || (CompanyDomainCheckResult = {}));
export var CompanySortType;
(function (CompanySortType) {
    CompanySortType[CompanySortType["TEXTUAL_SCORE"] = 10] = "TEXTUAL_SCORE";
    CompanySortType[CompanySortType["COMPANY_NAME_ASC"] = 20] = "COMPANY_NAME_ASC";
    CompanySortType[CompanySortType["COMPANY_NAME_DESC"] = 30] = "COMPANY_NAME_DESC";
    CompanySortType[CompanySortType["CREATION_DATE_ASC"] = 40] = "CREATION_DATE_ASC";
    CompanySortType[CompanySortType["CREATION_DATE_DESC"] = 50] = "CREATION_DATE_DESC";
    CompanySortType[CompanySortType["LAST_UPDATE_DATE_ASC"] = 60] = "LAST_UPDATE_DATE_ASC";
    CompanySortType[CompanySortType["LAST_UPDATE_DATE_DESC"] = 70] = "LAST_UPDATE_DATE_DESC";
    CompanySortType[CompanySortType["COMPANY_CUSTOMER_PERMISSION_ASC"] = 80] = "COMPANY_CUSTOMER_PERMISSION_ASC";
    CompanySortType[CompanySortType["COMPANY_CUSTOMER_PERMISSION_DESC"] = 90] = "COMPANY_CUSTOMER_PERMISSION_DESC";
})(CompanySortType || (CompanySortType = {}));
//# sourceMappingURL=domains.js.map